import styled, { css } from "styled-components";
import moment from "moment";
import { Col, DatePicker, Select } from "antd";
import { Controller } from "react-hook-form";
import { TInput } from "components/form/Field/TInput";
import { InputContainer, StyledTitle } from "pages/jobs/add";
import _ from "lodash";

const { Option } = Select;

const OtherInput = (props) => {
  const {
    control,
    setValue,
    errors,
    trigger,
    watch,
    getValues,
    bookSizeUnit,
    setBookSizeUnit,
  } = props;
  return (
    <>
      <Col span={3}>
        <InputContainer>
          <StyledTitle>Quantity</StyledTitle>
          <TInput
            errors={errors}
            name="quantity"
            placeholder="XXXX"
            defaultValue={getValues("quantity")}
            propsInput={{
              control: control,
            }}
            suffix={<StyledSuffix>pcs</StyledSuffix>}
          />
        </InputContainer>
      </Col>
      <Col span={7}>
        <InputContainer>
          <StyledTitle>Size</StyledTitle>
          <TInput
            errors={errors}
            name="general.size"
            defaultValue={getValues("general.size")}
            addonAfter={
              <Select
                defaultValue={bookSizeUnit}
                onChange={(e) => setBookSizeUnit(e)}
              >
                <Option value="INCI">INCI</Option>
                <Option value="CM">CM</Option>
              </Select>
            }
            placeholder="14x14"
            propsInput={{
              control: control,
            }}
          />
        </InputContainer>
      </Col>
      <Col span={6}>
        <InputContainer>
          <StyledTitle>Delivery Date</StyledTitle>
          <Controller
            control={control}
            name="delivery_date"
            render={() => (
              <StyledDatePicker
                error={Boolean(_.get(errors, "delivery_date"))}
                // defaultValue={watch("delivery_date")}
                value={
                  getValues("delivery_date") !== ""
                    ? moment(getValues("delivery_date"))
                    : ""
                }
                format="DD/MM/YYYY"
                onChange={(e) => {
                  setValue("delivery_date", e.format());
                  trigger("delivery_date");
                }}
                style={{ width: "100%" }}
              />
            )}
          />
          {errors && _.get(errors, "delivery_date") && (
            <StyledError>
              <p>{errors && _.get(errors, "delivery_date").message}</p>
            </StyledError>
          )}
        </InputContainer>
      </Col>
    </>
  );
};

const StyledSuffix = styled.p`
  color: ${(props) => props.theme.colors.grey[500]};
  text-transform: uppercase;
  font-size: ${(props) => props.theme.fontSize["xs"]};
  margin: 0;
`;

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;

const StyledDatePicker = styled(DatePicker)`
  ${(props) =>
    props.error &&
    css`
      border-color: ${(props) => props.theme.colors.red[600]};
    `};
`;

export default OtherInput;
